<template>
    <div class="loopInfo">
        <div class="litter">基本信息</div>
        <div class="info">
            <div class="left">
                <div class="name">{{currentLoop.device_name}}</div>
                <div class="type" >
                    <p>容量：{{getQuery('容量')}}</p>
                    <p>型号：{{currentLoop.device_model_name}}</p>
                    <p>品牌：{{currentLoop.device_brand_name}}</p>
                    <p>站点：{{currentLoop.area_name}}</p>
                </div>
            </div>
            <div class="statue column-center">
                <div class="row-center" style="min-height:70px">
                    <div class="item">
                        <div class="name">UPS状态</div>
                        <div class="val grey" v-if="upsate=='--'">--</div>
                        <div class="val"  style="color:#FD4238" v-else-if="upsate">{{upsate}}</div>
                        <div class="val" v-else>正常</div>
                    </div>
                    <div class="item">
                        <div class="name">备电时间</div>
                        <div class="val " v-if="getQuery('备电时间')!='--'">{{getQuery('备电时间')}}</div>
                        <div class="val grey" v-else>--</div>
                    </div>
                </div>
                <div class="row-center">
                    <div class="item">
                        <div class="name" v-if="this.mqttval('buzzer_status')==1">蜂鸣器状态：<span style="color:#0D94FF">开</span></div>
                        <div class="name" v-else-if="this.mqttval('buzzer_status')==0">蜂鸣器状态：<span style="color:#FD4238">关</span></div>
                        <div class="name " v-else>蜂鸣器状态：<span class="grey">--</span></div>
                    </div>
                </div>
            </div>
            <div class="imgshow row-center"><img src="@/assets/img/UPS2.png" alt=""></div>
        </div>
        <div class="litter" style="border:0">运行信息</div>
        <div class="box">
            <table>
                <tr v-for="item in option">
                    <th width="50%">{{item.name}}</th>
                    <td v-if="mqttval(item.data)!='--'">{{mqttval(item.data)}} {{item.unit}}</td>
                    <td v-else class="grey">{{mqttval(item.data)}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { deviceAll,loopList,GetWireByDeviceID } from "../../api/power";
import { floatFormat } from "../../util/MathUtil";
import { subscribeByNodesUPS } from '../../mqtt/index'
import { json } from "body-parser";
  export default {
    props:{
        currentLoop:Object
    },
    components:{
        
    },
    data() {
      return {
        option:[
            {
                name:"电池电压",
                data:"U",
                unit:"V"
            },{
                name:"温度",
                data:"Temperature",
                unit:"℃"
            },{
                name:"频率",
                data:"INPUT_F",
                unit:"Hz"
            },{
                name:"输入电压",
                data:"INPUT_U",
                unit:"V"
            },{
                name:"输出电压",
                data:"OUT_U",
                unit:"V"
            },
            {
                name:"电流百分比",
                data:"OUT_I",
                unit:"%"
            },
        ],
      };
    },
    computed:{
        upsate(){
            let ste = []
            let name = ['关机总','测试中','在线互动式','UPS故障','旁路','电池电压低','市电故障']
            let data = ['shutdown','test','online_interactive','ups_error','bypass','low_battery_voltage','mains_electricity']
            data.forEach(item=>{
                let mqtt = this.mqttval(item)
                // if(mqtt=='1'){
                    ste.push(mqtt)
                // }
            })
            console.log(ste,"ste")
            if(ste.join(',').indexOf('1')>-1){  //有异常
                let news = []
                ste.map((e,i)=>{
                    if(e==1){
                        news.push(name[i])
                    }
                })
                return news.join(',')
            }else if(ste.join(',').indexOf('0')>-1){
                let news = []
                ste.map((e,i)=>{
                    if(e==1){
                        news.push(name[i])
                    }
                })
                return news.join(',')
            }else if(ste.join(',').indexOf('--')>-1){
                let news = []
                ste.map((e,i)=>{
                    if(e=='--'){
                        news.push(name[i])
                    }
                })
                if(news.length==ste.length){
                    return '--'
                }
            }
            // return ste.join(',')
        },
        getQuery(){
            return function(name){
                let data = JSON.parse(this.currentLoop.device_details)
                for (let arr in data) {
                    for (const [key, value] of Object.entries(data[arr])) {
                        if(key==name){
                            return value
                        }
                        // console.log(`${key}: ${value}`);
                    }
                }
            }
            
        },
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
    },
    watch:{
        currentLoop(n,o){
            subscribeByNodesUPS([n.loop_url]);
        }
    },
    mounted(){
        if(this.currentLoop.loop_url){
            subscribeByNodesUPS([this.currentLoop.loop_url]);
        }
    },
    methods:{
        
        getMqttVal(f) {
			return (k, m) => {
				if (this.currentLoop && k) {
					k = this.currentLoop.loop_url + "/" + k;
                    let mqttVal = f(k);
                    if (m) {
                        mqttVal *= m;
                    }
                    mqttVal = floatFormat(mqttVal, 2);
                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }
                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                } else {
                    return "--";
				}
			};
		},
    }
  };
</script>

<style scoped lang="less">
.loopInfo{
    width: 100%;
    height: 100%;
    overflow: auto;
    .litter{
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.6vh;
        border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
        padding-left: 0.7vw;
        position: relative;
        color: #0D94FF;
        margin-bottom: 15px;
        &::before{
            content:'';
            width: 5rem;
            height: 2vh;
            background-color: #0D94FF;
            position: absolute;
            top: 40%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .box{
        table{
            width: 100%;
            border-collapse:collapse;
            th{
                background: #f5f7f9;
                font-size: 18rem;
                font-weight: bold;
                border: 1px solid #E5E5E5;
                height: 103rem;
                text-align: center;
            }
            td{
                font-size: 24rem;
                font-weight: bold;
                color: #0D94FF;
                border: 1px solid #E5E5E5;
                height: 103rem;
                text-align: center;
            }
        }
    }

    .info{
        .h(180);
        justify-content: space-between;
        margin-bottom: 20px;
        .left{
            float: left;
            .name{
                font-size: 24rem;
                font-weight: bold;
                line-height: 45px;
            }
            .type{
                font-size: 18rem;
                font-weight: 400;
                color: #666666;
            }
        }
        .imgshow{
            .w(181);
            float: right;
            margin-right: 20px;
            height: 100%;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            border-radius: 4px;
            img{
                max-height: 100%;
                max-width: 100%;
                transform: scale(1.3);
            }
        }
        .statue{
            .w(425);
            float: right;
            background: #f5f7f9;
            border-radius: 4px;
            height: 100%;
            text-align: center;
            .item{
                width: 50%;
            }
            .name{
                font-size: 18rem;
            }
            .row-center{
                align-items: flex-start;
                width: 100%;
            }
            .val{
                font-size: 18px;
                font-weight: 600;
                color: #0D94FF;
                // line-height: 55px;
            }
        }
    }
}
</style>